module.exports = __webpack_public_path__ + "img/startup-costs.75986331.png";